<template>
  <div v-if="shouldRender">
    <div class="mt-6" v-if="attribute && attribute.preHTML">
      <div v-html="attribute.preHTML" />
      <v-divider />
    </div>

    <div :class="`d-flex  ${completeRequired ? 'ml-n9' : ''}`">
      <v-tooltip v-if="completeRequired && showHeader" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="mr-2"
            icon
            open-on-click
            v-bind="attrs"
            v-on="on"
            small
            ><v-icon>fas fa-exclamation-circle</v-icon></v-btn
          >
        </template>
        <span>This field is required by Epic based on previous answers</span>
      </v-tooltip>

      <div class="flex-grow-1">
        <div class="d-flex align-right justify-space-between" v-if="showHeader">
          <label class="och-label pt-2"
            >{{ label }}<span v-if="required">{{ " *" }}</span></label
          >
          <div>
            <tooltip-help-text
              :label="label"
              :helpText="helpText"
              v-if="helpText"
            >
            </tooltip-help-text>
            <span v-if="!entityTypeListWithoutHistory.includes(entityName)">
              <dialog-value-history
                :attributeName="attributeName"
                :entityName="entityName"
                :id="id"
                v-if="id"
              ></dialog-value-history>
            </span>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DialogValueHistory from "./DialogValueHistory";
import TooltipHelpText from "./TooltipHelpText";

export default {
  components: {
    DialogValueHistory,
    TooltipHelpText,
  },
  data() {
    return {
      entityTypeListWithoutHistory: ["department", "organization"],
    };
  },
  props: {
    attribute: {
      required: true,
      type: Object,
    },
    attributeName: {
      required: true,
      type: String,
    },
    completeRequired: {
      default: false,
      type: Boolean,
    },
    entityName: {
      required: true,
      type: String,
    },
    helpText: {
      type: String,
    },
    label: {},
    shouldRender: {
      default: true,
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    id: {
      required: true,
    },
  },
};
</script>
